export const convertDigitsToArabic = (text: string | number, needConvert = true): string => {
  if (typeof text === "number") text = text.toString();
  return needConvert ? text.replace(/\d/g, (d) => "٠١٢٣٤٥٦٧٨٩"[d as unknown as number]) : text;
};
